// extracted by mini-css-extract-plugin
export default {"footerMain":"Footer_footerMain__YlEnJ"};